<template>
  <div class="en-flow-node" :style="styles" @click="click">
    <div class="flow-node-container">
      <div class="flow-node-main">
        <div class="left">
          <div class="left-line"></div>
          <div class="left-node"><img :src="nodeImg" /></div>
        </div>
        <div class="right-container">
          <div class="main">
            <div>
              <en-user-logo
                v-if="!isBranch"
                class="right-icon"
                size="48px"
                :userName="data.name"
                :imageUrl="data.userLogo"
              ></en-user-logo>
              <div
                v-else
                class="right-icon"
                style="
                  width: 48px;
                  height: 48px;
                  background: #f7bf28;
                  border-radius: 50%;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                <img
                  style="width: 20px; height: 20px"
                  src="../../assets/并签.png"
                />
              </div>
              <div class="right-name">
                {{ isBranch ? data.nodeName : data.name }}
              </div>
              <div class="right-detail">
                {{ isBranch ? '分支开始到分支结束' : data.nodeName }}
              </div>
              <div
                class="right-date"
                v-if="
                  data.isSupplyApproval === '0' ||
                  !(
                    !data.status ||
                    data.status === '000' ||
                    data.status === '002' ||
                    data.status === '003' ||
                    data.status === '004'
                  )
                "
              >
                {{ data.modifyTime }}
              </div>
              <div class="right-idea">
                {{
                  data.approvalComment &&
                  data.approvalComment.indexOf('[img]') === -1
                    ? data.approvalComment
                    : ''
                }}
              </div>
              <div class="right-arrow" v-if="isBranch">
                <i class="el-icon-arrow-right"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="show-list-level1" v-if="showList">
      <div class="title">
        <i
          class="close-icon el-icon el-icon-close"
          @click.stop="showList = false"
        ></i>
        审批流程
      </div>
      <div class="show-list-container">
        <en-flow-node
          v-for="(item, index) in list"
          :key="index"
          :data="item"
          :info="fullData"
        >
        </en-flow-node>
      </div>
    </div>
  </div>
</template>

<script>
import enUserLogo from '../en-user-logo'

export default {
  name: 'en-flow-node',
  props: ['data', 'styles', 'info'],
  components: { enUserLogo },
  data() {
    return {
      list: [],
      showList: false,
    }
  },
  watch: {
    showList(val) {
      if (val) {
        document.getElementsByClassName('business-model')[0].style.overflow =
          'hidden'
      } else {
        document.getElementsByClassName('business-model')[0].style.overflow =
          'auto'
      }
    },
  },
  computed: {
    isBranch() {
      return this.data.pattern === '006'
    },
    nodeImg() {
      let status = {
        '000': '提交',
        '001': '待处理',
        '002': '审批中',
        '003': '已审批',
        '004': '退回',
        '005': '收回',
        '006': '已终止',
      }
      let str = status[this.data.imgFlag]
        ? status[this.data.imgFlag]
        : status['000']
      return require('../../assets/' + str + '.png')
    },
  },
  methods: {
    click() {
      if (this.isBranch) {
        this.info.queryFlowBranchDetail(this.data, () => {
          this.list = this.data.children
          this.showList = true
        })
      }
    },
  },
}
</script>

<style lang="scss">
.en-flow-node {
  .show-list-level1 {
    position: fixed;
    z-index: 9;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #f7f7f7;

    .title {
      text-align: center;
      color: #ffffff;
      position: relative;
      width: 100%;
      height: 50px;
      line-height: 50px;
      background-color: #31415a;

      .close-icon {
        position: absolute;
        font-size: 32px;
        top: 9px;
        left: 9px;
      }
    }

    .show-list-container {
      margin-top: 20px;
      margin-right: 15px;
      height: calc(100% - 50px);
      overflow: auto;
      position: relative;
      z-index: 3;
    }
  }
  .flow-node-main {
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    align-content: center;
    .left {
      display: flex;
      display: -webkit-flex;
      position: relative;
      width: 56px;
      align-items: center;
      justify-content: center;
      .left-line {
        position: absolute;
        z-index: 0;
        left: 28px;
        top: 0px;
        width: 1px;
        height: 100%;
        background: #000000;
        opacity: 0.05;
      }
      .left-node {
        z-index: 1;
      }
    }
    .right-container {
      flex: 1;
      background: #fbfbfb;
      border: 1px solid #f3f3f3;
      border-radius: 4px;
      margin-bottom: 10px;
    }

    .main {
      width: 100%;
      justify-content: space-between;
      height: 80px;
      position: relative;
      font-weight: 400;
      .right-icon {
        position: absolute;
        left: 20px;
        top: 16px;
      }
      .right-name {
        position: absolute;
        left: 78px;
        top: 21px;
        line-height: 20px;
        font-size: 14px;
        color: #000000;
      }
      .right-idea {
        position: absolute;
        font-size: 12px;
        line-height: 20px;
        top: 45px;
        right: 20px;
        color: #606060;
        width: calc(50% - 5px);
        text-align: end;
      }
      .right-detail {
        position: absolute;
        left: 78px;
        top: 45px;
        font-size: 12px;
        line-height: 20px;
        color: #606060;
        width: 50%;
      }
      .right-arrow {
        position: absolute;
        top: 15px;
        right: 15px;
      }
      .right-date {
        position: absolute;
        top: 21px;
        right: 20px;
        font-size: 12px;
        line-height: 20px;
        color: #aeaeae;
      }
    }
  }
  .flow-node-open {
    background: #fbfbfb;
    border-radius: 4px;
    .right-container {
      margin-bottom: 20px;
    }
  }
}
</style>